import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.maintenance
    ? _c(
        "div",
        { staticClass: "min-w-0 w-full" },
        [
          _c(
            VCard,
            { attrs: { "justify-center": "" } },
            [
              _c("state-component", {
                attrs: {
                  state: "empty_state",
                  title: "En mantenimiento",
                  subtitle:
                    "Se están realizando algunas actualizaciones en el reporte.",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "min-w-0 w-full" },
        [
          _c("div", { staticClass: "display-1" }, [
            _vm._v(_vm._s(this.$route.params.title) + " - Reportes"),
          ]),
          _c("actions-component", {
            staticClass: "mt-1",
            scopedSlots: _vm._u([
              {
                key: "description",
                fn: function () {
                  return [
                    _c(VBreadcrumbs, {
                      staticClass: "pa-0",
                      attrs: { items: _vm.getBreadcrumbs },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            VCard,
            { staticClass: "mt-1", attrs: { width: "100%", height: "110%" } },
            [
              _c("iframe", {
                staticStyle: { border: "0" },
                attrs: {
                  frameborder: "0",
                  allowfullscreen: "",
                  width: "100%",
                  height: "100%",
                  src: _vm.dashboardUrl,
                },
              }),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }